import { t } from '../../../../../common/i18n.js'
import { Language } from '../../../../../common/types/i18n.js'
import { PortalBannerProps } from '../../../../components/portal-banner/portal-banner.js'

export interface Q12BannerState {
    hasActiveCampaign: boolean
    activeCampaignId?: number
    activeCampaignEnd?: string
    /** Texts the admin typed on the campaign (ET / EN); empty → default i18n text. */
    activeCampaignBannerText?: string | null
    activeCampaignBannerTextEn?: string | null
    activeCampaignAnswered: boolean
    lang: Language
}

/**
 * Q12 callout strip for the dashboard body, driven by the same campaign state
 * the sidebar Q12 button uses. While the period is open it invites the user to
 * fill in the survey; once they have answered it thanks them (no CTA) until
 * the campaign's end date passes, after which the state carries no campaign
 * and the strip disappears.
 */
/** The campaign's own text in `lang`, falling back to the other language; '' when neither is set. */
export const campaignBannerText = (
    texts: { et?: string | null; en?: string | null },
    lang: Language,
): string => {
    const preferred = (lang === 'en' ? texts.en : texts.et)?.trim()
    const other = (lang === 'en' ? texts.et : texts.en)?.trim()
    return preferred || other || ''
}

export const buildQ12Banner = (state: Q12BannerState): PortalBannerProps | undefined => {
    const {
        hasActiveCampaign,
        activeCampaignId,
        activeCampaignEnd,
        activeCampaignBannerText,
        activeCampaignBannerTextEn,
        activeCampaignAnswered,
        lang,
    } = state
    if (!hasActiveCampaign || !activeCampaignId) return undefined

    if (activeCampaignAnswered) {
        return { text: t.portalHero.callout.answeredSurveyText(lang) }
    }

    const end = activeCampaignEnd?.slice(0, 10)
    const formattedEnd = end ? end.split('-').reverse().join('.') : undefined
    const custom = campaignBannerText(
        { et: activeCampaignBannerText, en: activeCampaignBannerTextEn },
        lang,
    )
    return {
        text: custom || t.portalHero.callout.activeSurveyText(lang),
        deadline: formattedEnd ? t.portalHero.q12Tile.deadline(formattedEnd)(lang) : undefined,
        ctaLabel: t.portalHero.callout.startSurvey(lang),
        ctaUrl: `/survey/${activeCampaignId}`,
    }
}
